import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../../../srevices/api";

export const fetchWallets = createAsyncThunk(
    "wallets/fetchWallets",
    async (_, thunkApi) => {
      try {
        const response  = await axios.get(`${API_URL}wallet`);
        return response.data;
      } catch (err) {
        return thunkApi.rejectWithValue(err.message);
      }
    }
  );
  
  export const fetchWalletsById = createAsyncThunk(
    'wallets/fetchWalletsById',
    async (id, thunkApi) => {
      try {
       
        const response = await axios.get(`${API_URL}wallet/${id}`);
        return response.data;
      } catch (err) {
        return thunkApi.rejectWithValue(err.message);
      }
    }
  );